var map = {
	"./3D.svg": 5050,
	"./Front.svg": 1363,
	"./Side.svg": 7265,
	"./Top.svg": 2809,
	"./deckglSettings.svg": 8479,
	"./exportImage.svg": 1771,
	"./goHome.svg": 9731,
	"./hzi-logo.svg": 2562,
	"./saveUserSettings.svg": 8001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;